/**
 * "This playable is over the limit — still go ahead?"
 *
 * A warning rather than a refusal: the networks reject an oversized playable,
 * but which networks an export is actually for is the exporter's business, and
 * an export made to measure the size is a perfectly good reason to continue.
 *
 * Shared by the single and the batch download dialogs so one playable and
 * twenty are warned about in the same words, and so the question matches where
 * the export is going — downloading an oversized build costs nothing, sending
 * one to the client is what the pause is really for.
 */

import React from "react";
import PropTypes from "prop-types";
import { Button, Dialog, DialogTitle, Typography } from "@material-ui/core";
import { MAX_PLAYABLE_SIZE_MB } from "../modules/playableSizeCalculator";

export default function DialogPlayableSizeWarning({ versions, toDropbox, onConfirm, onCancel }) {
  return (
    <Dialog open={versions.length > 0} onClose={onCancel} maxWidth="xs">
      <DialogTitle disableTypography style={{ textAlign: "center" }}>
        <Typography variant="h6">Playable Size Warning</Typography>
      </DialogTitle>
      <div style={{ padding: "0 24px 8px", textAlign: "center" }}>
        <Typography>
          The maximum size for networks is <b>{MAX_PLAYABLE_SIZE_MB} MB</b>.
        </Typography>
        {versions.map((version) => (
          <Typography key={version.versionID} style={{ marginTop: "8px", fontWeight: "bold" }}>
            {`${version.versionName}: ${parseFloat((version.size / 1024 / 1024).toFixed(2))} MB`}
          </Typography>
        ))}
        <Typography style={{ marginTop: "12px" }}>
          {toDropbox
            ? "Are you sure you want to send it to Dropbox?"
            : "Are you sure you want to download?"}
        </Typography>
      </div>
      <div style={{ display: "flex", justifyContent: "center", gap: "16px", padding: "16px" }}>
        <Button
          variant="contained"
          style={{ backgroundColor: "#f44336", color: "#ffffff", fontWeight: "bold" }}
          onClick={onCancel}
        >
          No
        </Button>
        <Button
          variant="contained"
          style={{ backgroundColor: "#418989", color: "#ffffff", fontWeight: "bold" }}
          onClick={onConfirm}
        >
          Yes
        </Button>
      </div>
    </Dialog>
  );
}

DialogPlayableSizeWarning.propTypes = {
  /** The oversized ones: `{versionID, versionName, size}` in bytes. Empty closes it. */
  versions: PropTypes.array,
  toDropbox: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

DialogPlayableSizeWarning.defaultProps = { versions: [], toDropbox: false };
